export const PERIODICIDADES = [
    { valor: 'Diaria', sigla: 'D', nome: 'Diária' },
    { valor: 'Semanal', sigla: 'SM', nome: 'Semanal' },
    { valor: 'Mensal', sigla: 'M', nome: 'Mensal' },
    { valor: 'Semestral', sigla: 'ST', nome: 'Semestral' },
    { valor: 'Anual', sigla: 'A', nome: 'Anual' },
    { valor: 'Programada', sigla: 'PR', nome: 'Programada' },
];

export const nomePeriodicidade = (valor) =>
    PERIODICIDADES.find((p) => p.valor === valor)?.nome ?? valor;

export const DIAS_SEMANA = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];

export const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

const DIAS_NO_MES = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

const doisDigitos = (n) => String(n).padStart(2, '0');

const diaMes = (dia, mes) => `${doisDigitos(Math.min(dia, DIAS_NO_MES[mes - 1]))}/${doisDigitos(mes)}`;

export const descricaoAviso = (item) => {
    switch (item.periodicidade) {
        case 'Semanal':
            return item.diaAviso ? DIAS_SEMANA[item.diaAviso - 1]?.toLowerCase() ?? null : null;
        case 'Mensal':
            if (!item.diaAviso) return null;
            return item.diaAviso > 28 ? `dia ${item.diaAviso} (ou último dia)` : `dia ${item.diaAviso}`;
        case 'Semestral':
            return item.diaAviso && item.mesAviso
                ? `${diaMes(item.diaAviso, item.mesAviso)} e ${diaMes(item.diaAviso, item.mesAviso + 6)}`
                : null;
        case 'Anual':
            return item.diaAviso && item.mesAviso ? diaMes(item.diaAviso, item.mesAviso) : null;
        case 'Programada': {
            if (!item.dataProgramada) return null;
            const [ano, mes, dia] = item.dataProgramada.split('-');
            return `${dia}/${mes}/${ano}`;
        }
        default:
            return null;
    }
};

export const validarItem = (valores) => {
    if (!valores.acao?.trim()) return 'Informe a ação.';

    const { periodicidade } = valores;
    if (periodicidade === 'Programada') {
        if (!valores.dataProgramada) return 'Informe a data da manutenção programada.';
        if (Number.isNaN(new Date(`${valores.dataProgramada}T00:00:00`).getTime())) return 'Data da manutenção programada inválida.';
        return null;
    }

    if (periodicidade === 'Semanal') {
        const dia = Number(valores.diaAviso);
        if (valores.diaAviso !== '' && valores.diaAviso != null && (!Number.isInteger(dia) || dia < 1 || dia > 7)) {
            return 'Selecione um dia da semana válido.';
        }
        return null;
    }

    if (!['Mensal', 'Semestral', 'Anual'].includes(periodicidade)) return null;

    const temDia = valores.diaAviso !== '' && valores.diaAviso != null;
    const temMes = valores.mesAviso !== '' && valores.mesAviso != null;

    if (temDia) {
        const dia = Number(valores.diaAviso);
        if (!Number.isInteger(dia) || dia < 1 || dia > 31) return 'O dia do aviso deve estar entre 1 e 31.';
    }

    if (periodicidade !== 'Mensal' && temDia !== temMes) return 'Informe o dia e o mês do aviso, ou deixe os dois em branco.';

    if (temMes) {
        const mes = Number(valores.mesAviso);
        const mesMaximo = periodicidade === 'Semestral' ? 6 : 12;
        if (!Number.isInteger(mes) || mes < 1 || mes > mesMaximo) {
            return periodicidade === 'Semestral'
                ? 'No semestral, selecione o mês do primeiro semestre (Jan/Jul a Jun/Dez).'
                : 'Selecione um mês válido.';
        }
    }

    return null;
};

export const TIPOS_EQUIPAMENTO = [
    { valor: 'Compressor', nome: 'Compressores' },
    { valor: 'Condensador', nome: 'Condensadores' },
    { valor: 'Chiller', nome: 'Chillers' },
    { valor: 'Ambiente', nome: 'Ambientes' },
];

export const nomeTipoEquipamento = (valor) =>
    TIPOS_EQUIPAMENTO.find((t) => t.valor === valor)?.nome ?? valor;
